export const RESET_SETTINGS_CONFIRMATION =
  'Are you sure you want to reset the settings? The page will refresh';

export const RESET_SETTINGS_CONFIRM_TEXT = 'Reset Settings';

export const RESET_SETTINGS_ABORT_TEXT = 'go back';
